<template>
    <div class="newsletter component bg-green">
        <div class="grid grid-cols-12">
            <div class="col-span-12 md:col-span-9">
                <h2 class="headline-big">{{ data.contactTitle }} <span class="font-serif">/</span> <span class="text-white">{{ data.titleEnglish }}</span></h2>
            </div>
        </div>
        <div class="grid grid-cols-12">
            <div class="col-span-10 md:col-span-5 text-base-serif mt-6" v-html="data.textClean"></div>
        </div>
        <!-- <div class="grid grid-cols-12 mt-14 md:mt-22">
            <div class="col-span-12 md:col-span-4">
                <input type="text" placeholder="Navn" class="rounded-none uppercase w-full border-gray-darker border-b-[2px] bg-transparent text-black placeholder:text-black p-0 text-sm outline-0">
            </div>
            <div class="col-span-12 md:col-span-2">
                <input type="text" placeholder="Postnummer" class="max-md:headline-sm rounded-none uppercase w-full border-gray-darker border-b-[2px] bg-transparent text-black placeholder:text-black p-0 text-sm outline-0">
            </div>
            <div class="col-span-12 md:col-span-6">
                <input type="text" placeholder="Skriv din email" class="rounded-none uppercase w-full border-gray-darker border-b-[2px] bg-transparent text-black placeholder:text-black p-0 text-sm outline-0">
            </div>
        </div> -->


        <div id="mc_embed_shell">
            <div id="mc_embed_signup">
                <form id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" @submit.prevent="submitNewsletter">
                    <div id="mc_embed_signup_scroll" class="relative">

                        <div class="grid grid-cols-12 mt-14 md:mt-22">
                            <div class="col-span-12 md:col-span-4">
                                <div class="mc-field-group">
                                    <input v-model="form.name" placeholder="Navn" type="text" name="FNAME" class="max-md:headline-sm rounded-none uppercase w-full border-gray-darker border-b-[2px] bg-transparent text-black placeholder:text-black p-0 py-1.5 text-sm outline-0 text" id="mce-FNAME">
                                </div>
                            </div>
                            <div class="col-span-12 md:col-span-2">
                                <div class="mc-field-group">
                                    <input v-model="form.postalCode" placeholder="Postnummer" type="text" name="MMERGE3" class="max-md:headline-sm rounded-none uppercase w-full border-gray-darker border-b-[2px] bg-transparent text-black placeholder:text-black p-0 py-1.5 text-sm outline-0 text" id="mce-MMERGE3">
                                </div>
                            </div>
                            <div class="col-span-12 md:col-span-6 relative">
                                <div class="mc-field-group">
                                    <input v-model="form.email" placeholder="Skriv din email" type="email" name="EMAIL" class="max-md:headline-sm rounded-none uppercase w-full border-gray-darker border-b-[2px] bg-transparent text-black placeholder:text-black p-0 py-1.5 text-sm outline-0 required email" id="mce-EMAIL" required>
                                </div>

                                <button id="mc-embedded-subscribe" :disabled="status === 'pending'" class="button max-md:mt-12 md:absolute right-0 top-0 max-md:headline-sm uppercase bg-transparent text-black p-0 text-sm outline-0 z-50 cursor-pointer flex flex-row items-center gap-x-4 disabled:opacity-50">
                                    {{ status === 'pending' ? 'Tilmelder...' : 'Tilmeld nyhedsbrev' }}
                                    <svg class="w-6 h-6 md:w-9 md:h-9" width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="17.5" cy="17.5" r="16.5" stroke="black" stroke-width="2"/>
                                    <path d="M17.8343 24.7274L17.8345 24.7276C17.978 24.871 18.1726 24.9515 18.3755 24.9515C18.5784 24.9515 18.773 24.871 18.9166 24.7276L18.9167 24.7275L25.1042 18.54L25.1043 18.5399C25.2477 18.3963 25.3282 18.2017 25.3282 17.9989C25.3282 17.796 25.2477 17.6014 25.1043 17.4578L25.1042 17.4577L18.9167 11.2702L18.9168 11.2701L18.9103 11.2641C18.7652 11.1288 18.5732 11.0552 18.3749 11.0587C18.1765 11.0622 17.9873 11.1426 17.847 11.2828C17.7067 11.4231 17.6264 11.6124 17.6229 11.8107C17.6194 12.0091 17.693 12.201 17.8283 12.3462L17.8281 12.3463L17.8344 12.3525L22.7143 17.2332L9.43803 17.2332C9.23498 17.2332 9.04024 17.3139 8.89666 17.4575C8.75307 17.6011 8.67241 17.7958 8.67241 17.9989C8.67241 18.2019 8.75307 18.3967 8.89666 18.5402C9.04024 18.6838 9.23498 18.7645 9.43803 18.7645L22.7143 18.7645L17.8344 23.6452L17.8343 23.6453C17.6909 23.7889 17.6104 23.9835 17.6104 24.1864C17.6104 24.3892 17.6909 24.5838 17.8343 24.7274Z" fill="black" stroke="black" stroke-width="0.5"/>
                                    </svg>
                                </button>
                            </div>

                            <div class="col-span-12 relative">
                                <div id="mce-responses" class="clear">
                                    <div v-if="status === 'error'" class="response max-md:headline-sm text-sm" id="mce-error-response">{{ message }}</div>
                                    <div v-if="status === 'success'" class="response max-md:headline-sm text-sm" id="mce-success-response">{{ message }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>


    </div>
</template>

<script setup>
const props = defineProps({
    data: {
        type: Object,
        required: true
    }
})

const form = reactive({
    name: '',
    postalCode: '',
    email: '',
})
const status = ref('idle')
const message = ref('')

async function submitNewsletter() {
    status.value = 'pending'
    message.value = ''

    try {
        await $fetch('/api/newsletter', {
            method: 'POST',
            body: form
        })
        status.value = 'success'
        message.value = 'Tak for din tilmelding.'
        form.name = ''
        form.postalCode = ''
        form.email = ''
    } catch {
        status.value = 'error'
        message.value = 'Tilmeldingen mislykkedes. Prøv igen senere.'
    }
}
</script>

<style lang="scss" scoped>
.newsletter.component {
    @apply pt-[3rem] md:pt-[5rem];
}

input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus, 
input:-webkit-autofill:active{
    transition: background-color 9999999s ease-in-out 0s;
}

#mc_embed_signup :deep(div.mce_inline_error) {
    background-color: transparent;
    padding-left: 0;
    padding-right: 0;
}
</style>